
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

interface TradeFieldsProps {
  form: UseFormReturn<any>;
}

export const TradeFields = ({ form }: TradeFieldsProps) => {
  // Helper function to convert array to comma-separated string and vice versa
  const arrayToString = (arr?: string[] | null): string => {
    if (!arr) return '';
    return arr.join(', ');
  };

  const stringToArray = (str?: string): string[] => {
    if (!str) return [];
    return str.split(',').map(item => item.trim()).filter(item => item !== '');
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Trade Settings</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="traded_symbols"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="traded_symbols">Traded Symbols</FormLabel>
              <FormDescription>Enter comma-separated symbols (e.g. BTC, ETH)</FormDescription>
              <FormControl>
                <Input 
                  id="traded_symbols"
                  name="traded_symbols"
                  {...field}
                  value={arrayToString(field.value)} 
                  onChange={(e) => field.onChange(stringToArray(e.target.value))}
                  placeholder="BTC, ETH, USDT, etc." 
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="social_trading"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="social_trading">Social Trading</FormLabel>
              <FormDescription>Enter comma-separated values</FormDescription>
              <FormControl>
                <Input 
                  id="social_trading"
                  name="social_trading"
                  {...field}
                  value={arrayToString(field.value)} 
                  onChange={(e) => field.onChange(stringToArray(e.target.value))}
                  placeholder="e.g. copy-trading, signal-sharing" 
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          control={form.control}
          name="compounding"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
              <div className="space-y-0.5">
                <FormLabel htmlFor="compounding" className="text-base">Compounding</FormLabel>
                <FormDescription>
                  Enable compounding for this strategy
                </FormDescription>
              </div>
              <FormControl>
                <Switch
                  id="compounding"
                  name="compounding"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="risk_corridor"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
              <div className="space-y-0.5">
                <FormLabel htmlFor="risk_corridor" className="text-base">Risk Corridor</FormLabel>
                <FormDescription>
                  Enable risk corridor for this strategy
                </FormDescription>
              </div>
              <FormControl>
                <Switch
                  id="risk_corridor"
                  name="risk_corridor"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
